import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, ArrowRight, UtensilsCrossed } from "lucide-react";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import DishImage from "@/components/DishImage";
import PlateComposer from "@/components/PlateComposer";

export default function SharedMenu() {
  const { id } = useParams();
  const [menu, setMenu] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/menus/${id}`).then((r) => setMenu(r.data)).catch(() => setErr(true));
  }, [id]);

  if (err)
    return (
      <div className="min-h-[70vh] flex flex-col items-center justify-center gap-4 px-5 text-center">
        <p className="serif text-3xl text-[#1A1A1A]">Menu not found</p>
        <Link to="/build" className="btn-gold px-6 py-3 rounded-sm text-sm">Build your own menu</Link>
      </div>
    );
  if (!menu)
    return <div className="min-h-[70vh] flex items-center justify-center text-[#B08D4F]"><Loader2 className="animate-spin" /></div>;

  return (
    <div className="max-w-6xl mx-auto px-5 py-14" data-testid="shared-menu-page">
      <Seo title="A Shared Menu — Mayuresh Caterers" description="View a custom catering menu created with Mayuresh Caterers, Roha." />
      <div className="flex items-center gap-2 mb-8">
        <UtensilsCrossed className="text-[#C9A66B]" />
        <p className="label-tag text-[#B08D4F]">Shared Menu · {menu.occasion}</p>
      </div>

      <div className="grid lg:grid-cols-2 gap-12 items-start">
        <div className="card-lux rounded-sm p-6">
          <PlateComposer dishes={menu.dishes || []} />
        </div>
        <div>
          <h1 className="text-4xl font-semibold text-[#1A1A1A]">Menu for {menu.guest_count} guests</h1>
          <div className="mt-6 space-y-2">
            {(menu.dishes || []).map((d) => (
              <div key={d.id} className="flex items-center gap-3 py-2 border-b border-[#E5DCC9]" data-testid={`shared-dish-${d.id}`}>
                <div className="w-10 h-10 rounded-sm overflow-hidden shrink-0">
                  <DishImage src={d.image} alt={d.name} className="w-full h-full object-cover" />
                </div>
                <span className="text-[#1A1A1A]">{d.name}</span>
                <span className="text-xs text-[#5b554b] ml-auto">{d.category}</span>
              </div>
            ))}
          </div>
          <div className="bg-[#1A1A1A] rounded-sm p-6 text-white mt-8">
            <div className="flex justify-between"><span className="text-white/60 text-sm">Occasion</span><span className="serif text-2xl text-[#C9A66B]">{menu.occasion}</span></div>
            <div className="gold-line my-3" />
            <div className="flex justify-between"><span className="text-white/60 text-sm">Dishes · Guests</span><span className="serif text-2xl">{(menu.dishes||[]).length} · {menu.guest_count}</span></div>
          </div>
          <Link to="/build" className="btn-gold inline-flex items-center gap-2 px-6 py-3 rounded-sm text-sm mt-8">
            Customise this menu <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
}
